import { PartnersListState } from '../Kyc.types';
import { create } from 'zustand';

export const usePartnersList = create<PartnersListState>((set) => ({
  field: '',
  setField: (field) => set(() => ({ field })),
}));
